import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';

type BillingChangeSubscriptionHeaderProps = {
    isAuthenticated: boolean;
};

const BillingChangeSubscriptionHeader = ({
    isAuthenticated,
}: BillingChangeSubscriptionHeaderProps) =>
    isAuthenticated ? (
        <NavigationTabs.Billing
            className="mb-2"
            selection="changeSubscription"
        />
    ) : (
        <div className="grid place-content-center p-4 text-center">
            <SectionHeader
                className="mt-0"
                subtitle="Select the plan that best matches your company."
                title="MakeLeaps Billing Plans"
            />
        </div>
    );

export default BillingChangeSubscriptionHeader;
